<div class="wrapper">
    <app-appli-side-bar [sidebars]="sidebar" (clickEventIndex)="setFocusIndex($event)"></app-appli-side-bar>
    <div class="top_icon"></div>
    <div class="app_name">{{ appname }}</div>
    <div class="remote_control"></div>
    <div class="datetime">
        {{ now_date_obj.year }}.{{ now_date_obj.month }}.{{ now_date_obj.day }} {{ now_date_obj.hhmm }}
    </div>
    <div class="main_content_wrapper">
        <div class="main_content">

            <!--コンビニエンスストア -->
            <div *ngIf="hotelIndex == 0">
                <div class="ja" *ngIf="lang == 'jpn'">
                    <h2>コンビニエンスストア（ローソン）は2階にございます。
                    </h2>
                    <div class="panel">

                        <dl>
                            <dt>場所</dt>
                            <dd>
                                2階
                            </dd>
                        </dl>
                        <dl>
                            <dt>営業時間</dt>
                            <dd>
                                24時間
                            </dd>
                        </dl>
                    </div>

                </div>

                <div class="en" *ngIf="lang == 'eng'">
                    <h2>
                        Convenience Store (LAWSON) is located on the 2nd floor.
                    </h2>
                    <div class="panel">

                        <dl>
                            <dt>Location</dt>
                            <dd>
                                2 F
                            </dd>
                        </dl>
                        <dl>
                            <dt>Available</dt>
                            <dd>
                                24 hours
                            </dd>
                        </dl>
                    </div>
                </div>

            </div>
            <!--コインランドリー-->
            <div class="laundry" *ngIf="hotelIndex == 1">
                <div class="ja" *ngIf="lang == 'jpn'">
                    <h2>全自動洗濯乾燥機を御用意しております。</h2>
                    <div class="panel">

                        <dl>
                            <dt>設置場所</dt>
                            <dd>
                                21階
                            </dd>
                        </dl>
                        <!-- <dl>
                            <dt>設置台数</dt>
                            <dd>
                                3台
                            </dd>
                        </dl> -->
                    </div>
                    <table>
                        <tr>
                            <td>
                            </td>
                            <th>
                                洗濯〜乾燥(標準)
                            </th>
                            <th>
                                洗濯〜乾燥(少量)
                            </th>
                            <th>
                                洗濯のみ
                            </th>
                            <th>
                                追加乾燥
                            </th>
                        </tr>
                        <tr>
                            <th>洗濯容量</th>
                            <td>
                                3kgまで
                            </td>
                            <td>
                                1kgまで
                            </td>
                            <td>
                                6kgまで
                            </td>
                            <td span=3>
                                3kgまで
                            </td>

                        </tr>

                        <tr>
                            <th>目安時間</th>
                            <td>
                                120分
                            </td>
                            <td>
                                80分
                            </td>
                            <td>
                                35分
                            </td>
                            <td rowspan=2>30分/100円</td>

                        </tr>


                        <tr>
                            <th>料金</th>
                            <td>
                                500円
                            </td>
                            <td>
                                400円
                            </td>
                            <td>
                                300円
                            </td>
                            <td></td>

                        </tr>


                    </table>

                    <div>
                        <p style="text-align:right">
                            <small>洗剤は自動投入されます</small>
                        </p>
                    </div>
                </div>

                <div class="en" *ngIf="lang == 'eng'">
                    <h2>Automatic Washing Machines and Dryers are available.</h2>
                    <div class="panel">

                        <dl>
                            <dt>Location</dt>
                            <dd>
                                21F
                            </dd>
                        </dl>
                        <!-- <dl>
                            <dt>Number</dt>
                            <dd>
                                3
                            </dd>
                        </dl> -->
                    </div>
                    <table>
                        <tr>
                            <td>
                            </td>
                            <th>
                                Wash & Dry<br />(Regular)
                            </th>
                            <th>
                                Wash & Dry<br />(Small Load)
                            </th>
                            <th>
                                Wash
                            </th>
                            <th>
                                Dry more
                            </th>
                        </tr>
                        <tr>
                            <th>Capacity</th>
                            <td>
                                up to 3kg
                            </td>
                            <td>
                                up to 1kg
                            </td>
                            <td>
                                up to 6kg
                            </td>
                            <td span=3>
                                up to 3kg
                            </td>

                        </tr>

                        <tr>
                            <th>Est. Time</th>
                            <td>
                                120 min
                            </td>
                            <td>
                                80 min
                            </td>
                            <td>
                                35 min
                            </td>
                            <td rowspan=2>30 min / 100 yen</td>

                        </tr>


                        <tr>
                            <th>Price</th>
                            <td>
                                500 yen
                            </td>
                            <td>
                                400 yen
                            </td>
                            <td>
                                300 yen
                            </td>
                            <td></td>

                        </tr>


                    </table>

                    <div>
                        <p style="text-align:right">
                            <small>No need to add detergent (automatic).</small>
                        </p>
                    </div>
                </div>
            </div>
            <!--喫煙所-->
            <div *ngIf="hotelIndex == 2">
                <div class="ja" *ngIf="lang == 'jpn'">
                    <h2>
                        当ホテルは全館禁煙です。
                    </h2>
                    <div class="panel">

                        <dl class="smoke">
                            <dt>設置場所</dt>
                            <dd>
                                2階館外、出入口出られた左側にございます
                            </dd>
                        </dl>
                    </div>
                </div>

                <div class="en" *ngIf="lang == 'eng'">
                    <h2>
                        Smoking is only permitted in designated smoking areas.
                    </h2>
                    <div class="panel">

                        <dl class="smoke-en">
                            <dt>Location</dt>
                            <dd>
                                Outside the building entrance on the 2ndfloor<br> to the <b>left hand</b> side.
                            </dd>
                        </dl>
                    </div>
                </div>

            </div>

            <!--自動販売機 -->
            <div *ngIf="hotelIndex == 3">
                <div class="ja" *ngIf="lang == 'jpn'">
                    <h2>自動販売機・製氷機は21階にございます。
                    </h2>
                    <div class="panel">

                        <dl>
                            <dt>設置場所</dt>
                            <dd>
                                21階
                            </dd>
                        </dl>
                        <dl>
                            <dt>利用可能時間</dt>
                            <dd>
                                24時間
                            </dd>
                        </dl>
                    </div>

                </div>

                <div class="en" *ngIf="lang == 'eng'">
                    <h2>
                        Vending machines and Ice machine are available.
                    </h2>
                    <div class="panel">

                        <dl>
                            <dt>Location</dt>
                            <dd>
                                21 F
                            </dd>
                        </dl>
                        <dl>
                            <dt>Available</dt>
                            <dd>
                                24 hours
                            </dd>
                        </dl>
                    </div>
                </div>

            </div>
            <!-- Money Exchange -->
            <div *ngIf="hotelIndex == 4">
                <div class="ja" *ngIf="lang == 'jpn'">
                    <h2>外貨両替機・SIM販売機は1階にございます。</h2>
                    <div class="exchange_img">
                        <img src="assets/hotel-info/exchange_sim.jpg">
                    </div>
                    <div class="panel">

                        <dl>
                            <dt>設置場所</dt>
                            <dd>
                                1階
                            </dd>
                        </dl>
                        <dl>
                            <dt>利用可能時間</dt>
                            <dd>
                                24時間
                            </dd>
                        </dl>
                    </div>

                </div>

                <div class="en" *ngIf="lang == 'eng'">
                    <h2>
                        Money Exchange and SIM Card are available.
                    </h2>
                    <div class="exchange_img">
                        <img src="assets/hotel-info/exchange_sim.jpg">
                    </div>

                    <div class="panel">

                        <dl>
                            <dt>Location</dt>
                            <dd>
                                1 F
                            </dd>
                        </dl>
                        <dl>
                            <dt>Available</dt>
                            <dd>
                                24 hours
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>



        </div>
    </div>
</div>